var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurgerBlackRed = function SvgBurgerBlackRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213,
    height: 213,
    viewBox: "0 0 213 213"
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 2,
    y: 2,
    width: 209,
    height: 209,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAADRAgMAAAAvVL98AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUAAADqOUIAAADqOULhxOiVAAAAAnRSTlMAAHaTzTgAAAABYktHRACIBR1IAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wYVBRE4yZPI5AAAAGVJREFUaN7t1UENwDAMBEGTLB/jKYqSKJ4WQxJLcaTZ//xOurgnyqBOUxljURRFUVSt6v+V1KqSJGlv/b+SqlA5vAuKoiiKqlT9v5JaVZIk7e2b6KGOU+81FkVRFEXVqv5fSS2qHxLtErHMDUzEAAAAAElFTkSuQmCC"
  })));
};
export default SvgBurgerBlackRed;